module.exports = __webpack_public_path__ + "img/log-file.35c8547b.svg";